import { render, staticRenderFns } from "./workshop.vue?vue&type=template&id=40acd370&scoped=true"
import script from "./workshop.vue?vue&type=script&lang=js"
export * from "./workshop.vue?vue&type=script&lang=js"
import style0 from "./workshop.vue?vue&type=style&index=0&id=40acd370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acd370",
  null
  
)

export default component.exports